// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"9dc0f022","203":"9dc0f022","344":"9dc0f022","736":"9dc0f022"}[chunkId] + ".chunk.css";
};